<template>
    <div id="wrapper"></div>
</template>

<script>
const typeformId = 'GUBS7V1g';

export default {
    name: 'Home',
    mounted() {
        window.tf.createWidget(typeformId, {
            container: document.getElementById("wrapper"),
            onSubmit: (data) => {
                this.$router.replace({
                    name: 'results',
                    params: { responseId: data.responseId },
                });
            }
        });
    },
};
</script>